const splitAddress = (address) => {
  // Use regex to correctly split the address and preserve '[]' as a separate part
  const parts = address.split(/(\[\])|\.|\[\]/).filter(Boolean);
  return parts;
};

const extracerForValidations = (data, address, tttt) => {
  // const parts = address.split(/[\.\[\]]+/).filter(Boolean); // Split address by '.' and '[]'
  const parts = splitAddress(address); // Split address by '.' and '[]'
  if (tttt === "tttt") {
    console.log("data", data);
  }
  let current = data;
  let processedPath = []; // To track the processed path

  for (let i = 0; i < parts.length; i++) {
    // If the current field is null or undefined, return null
    if (current === null || typeof current !== "object") {
      return { value: null, isComplete: false, processedPath };
    }

    // If we encounter an array in the path
    if (parts[i] === "[]" && i !== parts.length - 1) {
      return { value: current, isComplete: false, processedPath };
    } else if (Array.isArray(current)) {
      // Check if there's anything after the array in the path
      if (i < parts.length - 1) {
        return { value: current, isComplete: false, processedPath }; // Incomplete // There's more after [], return incomplete
      }
      return { value: current, isComplete: true, processedPath }; // Reached end of path
    }

    // Move to the next nested field in the object
    processedPath.push(parts[i]);
    current = current[parts[i]];
  }

  // If the loop completes, return the final value (object, string, etc.) as complete
  return { value: current, isComplete: true, processedPath };
};

export default extracerForValidations;
